import { PaymentGatewayModel as GatewayType } from '@/http/models/PaymentGateway'
import { toast } from 'sonner'

import { useEffect, useState } from 'react'

import { PaymentGatewayModel } from '@/types/model/PaymentGateway'

export const usePaymentGatewaysTable = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<PaymentGatewayModel.Gateway[]>([])
  const [gatewayDialogOpen, setGatewayDialogOpen] = useState(false)
  const [editGateway, setEditGateway] = useState<PaymentGatewayModel.Gateway | null>(null)
  const [updateLoading, setUpdateLoading] = useState(false)

  const fetchGateways = async () => {
    setLoading(true)
    const response = await GatewayType.getList()
    if (response.success) {
      setData(response.data.result)
    } else {
      toast.error(response.error?.data?.message || 'Failed to fetch payment gateways')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchGateways()
  }, [])

  const openEditDialog = (gateway: PaymentGatewayModel.Gateway) => {
    setEditGateway(gateway)
    setGatewayDialogOpen(true)
  }

  const closeDialog = () => {
    setGatewayDialogOpen(false)
    setEditGateway(null)
  }

  const handleUpdateGateway = async (key: string, body: any) => {
    setUpdateLoading(true)
    const response = await GatewayType.update({
      params: { key },
      body,
    })

    if (response.success) {
      toast.success('Payment gateway updated successfully')
      closeDialog()
      fetchGateways()
    } else {
      toast.error(response.error?.data?.message || 'Failed to update payment gateway')
    }
    setUpdateLoading(false)
  }

  return {
    loading,
    data,
    gatewayDialogOpen,
    editGateway,
    updateLoading,
    openEditDialog,
    closeDialog,
    handleUpdateGateway,
    refresh: fetchGateways,
  }
}
